// 正式
module.exports = {
  url: "http://www.lakelandbook.com/",
  baseUrl: "http://www.lakelandbook.com/",
  appid: "",
};
